import {CalculatorPage, MemoAppPage} from '../pages';

export interface PortfolioItem {
    id: number;
    title: string;
    description: string;
    link: string;
    component: React.FC; // ページコンポーネントを直接関連付け
}
  
export const portfolioItems: PortfolioItem[] = [
{
    id: 1,
    title: '四則演算',
    description: 'シンプルな四則演算アプリ',
    link: '/portfolio/calculator',
    component: CalculatorPage,
},
{
    id: 3,
    title: 'SNS風メモアプリ',
    description: 'SNS風にメモをすることができる',
    link: '/portfolio/memo',
    component: MemoAppPage,
},
];
  